import React from "react"
import { makeStyles } from "tss-react/mui"
import { Box, Typography, TableCell, TableSortLabel } from "@mui/material"
import { FaIcon } from "../../../../mp-core/icons"

const styles = makeStyles()(() => ({
  tableCellRoot: {
    borderBottom: 0,
    paddingTop: 2,
    paddingBottom: 2,
    whiteSpace: "nowrap"
  }
}))

type SortDirection = "asc" | "desc"

type sortType = {
  label: string
  direction: SortDirection
}

function SortIcon({ sortDirection }: any) {
  if (sortDirection === "asc") {
    return (
      <Box color="textPrimary" fontSize={12} pl={2}>
        <FaIcon solid name="sort-up" size="inherit" />
      </Box>
    )
  }

  if (sortDirection === "desc") {
    return (
      <Box color="textPrimary" fontSize={12} pl={2}>
        <FaIcon solid name="sort-down" size="inherit" />
      </Box>
    )
  }

  return (
    <Box color="primary.200" fontSize={12} pl={2}>
      <FaIcon solid name="sort" size="inherit" />
    </Box>
  )
}

interface Props {
  title: string
  prop?: string | any
  currentSortLabel: sortType
  sortable?: boolean
  setSortLabel: (label: sortType) => void
  sortByProp?: (prop: any) => void
}

const TableSortCell: React.FC<React.PropsWithChildren<Props>> = (
  props: Props
) => {
  const {
    title,
    currentSortLabel,
    sortable = true,
    setSortLabel,
    prop,
    sortByProp
  } = props
  const { classes } = styles()

  function getNextDirection(): SortDirection {
    if (currentSortLabel.label === title) {
      return currentSortLabel.direction === "asc" ? "desc" : "asc"
    }
    return "asc"
  }

  const onSortClick = () => {
    const direction = getNextDirection()
    if (sortByProp && prop) sortByProp(prop)
    setSortLabel({
      label: title,
      direction
    })
  }
    
  function getSortIcon() {
    return (
      <SortIcon
        sortDirection={
          currentSortLabel.label === title ? currentSortLabel.direction : "none"
        }
      />
    )
  }

  const isActive = currentSortLabel.label === title
  const direction = isActive ? currentSortLabel.direction : undefined

  return (
    <TableCell
      className={classes.tableCellRoot}
      variant="head"
      align="left"
    >
      {!sortable ? (
        <Typography variant="h5" component="p">
          {title}
        </Typography>
      ) : (
        <TableSortLabel
          active={isActive}
          direction={direction || "asc"}
          onClick={onSortClick}
          IconComponent={getSortIcon}
          aria-label={
            isActive
              ? `${title}, sorted ${currentSortLabel.direction === "asc" ? "ascending" : "descending"}`
              : `${title}, not sorted`
          }
        >
          <Typography variant="h5" component="p" aria-hidden="true">
            {title}
          </Typography>
        </TableSortLabel>
      )}
    </TableCell>
  )
}
export default TableSortCell